import React, { useEffect } from "react";

export const useServiceSeo = (seo) => {
  useEffect(() => {
    if (!seo) return undefined;
    const meta = document.querySelector('meta[name="description"]');
    const prevTitle = document.title;
    const prevDesc = meta?.getAttribute("content");
    document.title = seo.title;
    meta?.setAttribute("content", seo.description);
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-faq-schema", "true");
    script.text = JSON.stringify(seo.schema);
    document.head.appendChild(script);
    return () => {
      document.title = prevTitle;
      if (prevDesc) meta?.setAttribute("content", prevDesc);
      script.remove();
    };
  }, [seo]);
};

export const SeoSections = ({ seo }) => (
  <div className="space-y-12" data-testid="seo-sections">
    {seo.sections.map((s) => (
      <div key={s.h2} className="fade-up">
        <h2 className="font-heading font-extrabold text-[#1B2A4A] text-[24px] md:text-[30px] leading-tight">
          {s.h2}
        </h2>
        {s.body && <p className="text-[#57616e] text-[16px] leading-relaxed mt-4">{s.body}</p>}
        {s.subs && (
          <div className="grid md:grid-cols-3 gap-4 mt-6">
            {s.subs.map((sub) => (
              <div key={sub.h3} className="bg-white rounded-2xl border border-[#DEE6EE] p-5">
                <h3 className="font-heading font-bold text-[17px] text-[#1B2A4A] leading-snug">{sub.h3}</h3>
                <p className="text-[#57616e] text-[14.5px] leading-relaxed mt-2">{sub.body}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    ))}
  </div>
);

export const SeoFaqs = ({ faqs }) => (
  <section className="pt-14 md:pt-16 pb-14 px-5 md:px-8" data-testid="service-faqs">
    <div className="max-w-4xl mx-auto">
      <h2 className="font-heading font-extrabold text-[#1B2A4A] text-[24px] md:text-[32px] leading-tight text-center">
        Frequently Asked Questions
      </h2>
      <div className="mt-9 space-y-4">
        {faqs.map((f, i) => (
          <div key={f.q} data-testid={`service-faq-${i}`} className="bg-white rounded-2xl border border-[#DEE6EE] p-6">
            <h3 className="font-heading font-bold text-[16.5px] text-[#1B2A4A] leading-snug">{f.q}</h3>
            <p className="text-[#57616e] text-[15px] leading-relaxed mt-2">{f.a}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
